const L = {
  EXTRA_SMALL: "xs",
  SMALL: "sm",
  DEFAULT: "md",
  LARGE: "lg",
  EXTRA_LARGE: "xl"
}, A = {
  COMBOBOX_LABEL_SIZES: L
};
export {
  L as COMBOBOX_LABEL_SIZES,
  A as default
};
//# sourceMappingURL=combobox-constants.js.map
